module.exports = __webpack_public_path__ + "img/20200515_160740.d8af63a7.jpg";